import { render, staticRenderFns } from "./table-list.vue?vue&type=template&id=f5d77784&scoped=true&"
import script from "./table-list.vue?vue&type=script&lang=js&"
export * from "./table-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d77784",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5d77784')) {
      api.createRecord('f5d77784', component.options)
    } else {
      api.reload('f5d77784', component.options)
    }
    module.hot.accept("./table-list.vue?vue&type=template&id=f5d77784&scoped=true&", function () {
      api.rerender('f5d77784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/tdc-manage/account/details/modules/table-list.vue"
export default component.exports